export default __webpack_public_path__ + "static/media/36t.ec582e63.jpg";